import axios from "axios"
import router from "../router";
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

//ceshi
var BASE_URL = process.env.NODE_ENV === 'http://localhost:8081' //线上跨域，取消域名

// 创建基请求
const $http = axios.create({
  baseURL: BASE_URL,
  timeout: 60000, // 超时时间 1分钟；
  withCredentials: true
});
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
// 请求拦截器
$http.interceptors.request.use(config => {
  config.cancelToken = source.token; // 全局添加cancelToken
  let token = sessionStorage.getItem('token')
  if (token) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    config.headers.common['token'] = token;
  }
  return config
}, err => {
  console.log(err);
  return Promise.reject(err);
})

//响应拦截器  处理错误
//$http.interceptors.response.use(con)

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function POST(url, params) {
  return $http.post(url, params, {
    headers: {
      'auth': 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * post方法，对应formdata请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function FORMDATA(url, params) {
  return $http.post(url, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * get方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} responseType [responseType]
 */
export function GET(url, params, responseType) {
  return $http.get(url, {
    params: params,
    responseType: responseType
  })
}
/**
 * get 获取  pdf 流文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} responseType [responseType]
 */
export function GETPDF(url, params, responseType) {
  return $http.get(url, {
    params: params,
    responseType: responseType,
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
/**
 * get 获取  流文件  下载
 * @param {String} url [请求的url地址]
 */
export function getFiles(url) {
  return axios.request({
    url: url,
    method: 'get',
    responseType: 'blob'
  })
}
/**
 * post方法，对应post请求  上传文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function FILE(url, params) {
  return $http.post(url, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 添加响应拦截器
$http.interceptors.response.use(function (res) {
  if (res.data.code == '1114' || res.data.code == 1114) {
    source.cancel()
    router.app.$alert('登录超时或您还没有登录，请登录后操作', '提示', {
      confirmButtonText: '确定',
      callback: action => {
        window.location.href = "/";
      }
    });
  }
  if (res.data.code == '1112' || res.data.code == 1112) {
    router.app.$confirm(res.data.msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      window.location.href = "/";
      sessionStorage.setItem("token", "");
    }).catch(() => { });
  }
  return res.data;
}, function (error) {
  if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
    return new Promise(() => { });
  } else {
    return Promise.reject(error);
  }
});



// WEBPACK FOOTER //
// ./src/axios/axios.js